// AAMVA Issuer Identification Number (IIN) → 2-char jurisdiction code.
// Source: AAMVA DL/ID Card Design Standard, Annex D (IIN registry). The
// numbers are assigned by ANSI/AAMVA and effectively constant — a
// jurisdiction either has one or hasn't been assigned one yet. Adding a
// row is the only maintenance this file ever needs.
//
// Coverage: all 50 US states + DC + the five US territories that AAMVA
// has assigned IINs for, plus every Canadian province (an MN border
// shop sees Ontario and Manitoba cards). Mexican consular IDs are not
// AAMVA-compliant and won't parse as DL — they error cleanly.

export const IIN_TO_STATE: Readonly<Record<string, string>> = Object.freeze({
  // --- United States (50 states + DC) ---
  "636033": "AL", // Alabama
  "636059": "AK", // Alaska
  "636026": "AZ", // Arizona
  "636021": "AR", // Arkansas
  "636014": "CA", // California
  "636020": "CO", // Colorado
  "636006": "CT", // Connecticut
  "636011": "DE", // Delaware
  "636043": "DC", // District of Columbia
  "636010": "FL", // Florida
  "636055": "GA", // Georgia
  "636047": "HI", // Hawaii
  "636050": "ID", // Idaho
  "636035": "IL", // Illinois
  "636037": "IN", // Indiana
  "636018": "IA", // Iowa
  "636022": "KS", // Kansas
  "636046": "KY", // Kentucky
  "636007": "LA", // Louisiana
  "636041": "ME", // Maine
  "636003": "MD", // Maryland
  "636002": "MA", // Massachusetts
  "636032": "MI", // Michigan
  "636038": "MN", // Minnesota
  "636051": "MS", // Mississippi
  "636030": "MO", // Missouri
  "636008": "MT", // Montana
  "636054": "NE", // Nebraska
  "636049": "NV", // Nevada
  "636017": "NH", // New Hampshire
  "636036": "NJ", // New Jersey
  "636009": "NM", // New Mexico
  "636001": "NY", // New York
  "636004": "NC", // North Carolina
  "636034": "ND", // North Dakota
  "636023": "OH", // Ohio
  "636058": "OK", // Oklahoma
  "636029": "OR", // Oregon
  "636025": "PA", // Pennsylvania
  "636052": "RI", // Rhode Island
  "636005": "SC", // South Carolina
  "636042": "SD", // South Dakota
  "636053": "TN", // Tennessee
  "636015": "TX", // Texas
  "636062": "UT", // Utah
  "636024": "VT", // Vermont
  "636000": "VA", // Virginia
  "636045": "WA", // Washington
  "636061": "WV", // West Virginia
  "636031": "WI", // Wisconsin
  "636060": "WY", // Wyoming

  // --- US territories with AAMVA IINs ---
  "636019": "PR", // Puerto Rico
  "636040": "VI", // US Virgin Islands
  "636057": "GU", // Guam
  "604427": "AS", // American Samoa
  "636069": "MP", // Northern Mariana Islands

  // --- Canadian provinces/territories (common border-shop scans) ---
  "636016": "ON", // Ontario
  "636048": "QC", // Quebec
  "636013": "BC", // British Columbia
  "636012": "AB", // Alberta
  "636044": "NS", // Nova Scotia
  "636027": "NB", // New Brunswick
  "636028": "SK", // Saskatchewan
  "636039": "MB", // Manitoba
  "636066": "NL", // Newfoundland and Labrador
  "604426": "PE", // Prince Edward Island
  "604428": "NT", // Northwest Territories
  "604429": "NU", // Nunavut
  "604430": "YT", // Yukon
});

export function lookupIin(iin: string): string | null {
  return IIN_TO_STATE[iin] ?? null;
}
